"use client";

import React, { useState, useEffect } from "react";
import { siteConfig, QuoteItem } from "@/config/site.config";

export const CitaFilosofica: React.FC = () => {
  const [quoteIndex, setQuoteIndex] = useState<number>(0);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    try {
      const stored = localStorage.getItem("copleston_last_quote_idx");
      let nextIdx = 0;
      if (stored !== null) {
        nextIdx = (parseInt(stored, 10) + 1) % siteConfig.citas.length;
      } else {
        nextIdx = Math.floor(Math.random() * siteConfig.citas.length);
      }
      localStorage.setItem("copleston_last_quote_idx", nextIdx.toString());
      setQuoteIndex(nextIdx);
    } catch {
      // Fallback si localStorage no está disponible
      setQuoteIndex(0);
    }
  }, []);

  const quote: QuoteItem = siteConfig.citas[quoteIndex] || siteConfig.citas[0];

  return (
    <section className="relative py-16 md:py-20 px-6 md:px-12 bg-bg-secondary/40 border-y border-gold/15 overflow-hidden">
      {/* Glow de fondo discreto */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(197,160,89,0.06),transparent_70%)] pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10 text-center flex flex-col items-center">
        {/* Adorno superior clásico */}
        <div className="flex items-center gap-3 mb-6 opacity-70">
          <span className="w-12 h-[1px] bg-gradient-to-r from-transparent to-gold" />
          <span className="font-serif text-xs md:text-sm text-gold tracking-[0.3em] uppercase">
            Pensamiento Vivo
          </span>
          <span className="w-12 h-[1px] bg-gradient-to-l from-transparent to-gold" />
        </div>

        {/* Cita en cursiva con serif clásica */}
        <blockquote className="relative my-2 px-4 md:px-8">
          <p
            className={`font-serif italic text-xl md:text-2xl lg:text-3xl text-text-pure font-light leading-relaxed tracking-wide transition-opacity duration-700 ${
              isClient ? "opacity-100" : "opacity-90"
            }`}
          >
            &ldquo;{quote.cita}&rdquo;
          </p>
        </blockquote>

        {/* Separador fino dorado */}
        <div className="w-16 h-[1px] bg-gold/40 my-6" />

        {/* Autor y Obra */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs md:text-sm font-sans tracking-widest uppercase">
          <cite className="font-medium text-gold not-italic">
            {quote.autor}
          </cite>
          <span className="hidden sm:inline text-gold/40">·</span>
          <span className="text-text-muted font-light">
            {quote.obra} ({quote.epoca})
          </span>
        </div>
      </div>
    </section>
  );
};
